import { render } from "./BoxSpinner.vue?vue&type=template&id=69cb4493&scoped=true"
const script = {}

import "./BoxSpinner.vue?vue&type=style&index=0&id=69cb4493&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cb4493"],['__file',"src/components/layout/BoxSpinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69cb4493"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69cb4493', __exports__)) {
    api.reload('69cb4493', __exports__)
  }
  
  module.hot.accept("./BoxSpinner.vue?vue&type=template&id=69cb4493&scoped=true", () => {
    api.rerender('69cb4493', render)
  })

}


export default __exports__